class ContactsController implements ng.IComponentController {

    constructor() {
        'ngInject';
        // console.log('ContactsController');
    }
}

export const contactsComponent: ng.IComponentOptions = {
    controller: ContactsController,
    template: require('./contacts.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/contacts/contacts.component.ts